import { AnimatePresence, motion } from 'motion/react';
import PropTypes from 'prop-types';

import { Button } from '../button/new';
import { Flex } from '../grid';
import { IOSButtonWrapper } from '../ios-button-wrapper';
import { Label, P } from '../typography/new';
import { useIsMinWidth } from '../../hooks/use-is-min-width';

const ScreenButton = ({ onClick, itemCount, price }) => {
  const isWeb = useIsMinWidth('lg');

  const showScreenCheckoutButton = !isWeb && itemCount > 0 && !!onClick;

  if (!showScreenCheckoutButton) {
    return null;
  }

  return (
    <IOSButtonWrapper fixedBreakpoint="lg">
      <Button
        as={motion.button}
        initial={{ y: 100 }}
        animate={{ y: 0 }}
        transition="0.2s ease-in-out 0.3s"
        widthType="full"
        variant="actionScreen"
        px="16px"
        size="tall"
        leftContent={
          <Flex
            justifyContent="center"
            alignItems="center"
            height={32}
            width={32}
            flexShrink={0}
            overflow="hidden"
            position="relative"
            borderRadius="100%"
          >
            <Flex
              position="absolute"
              borderRadius="100%"
              background="black"
              opacity="0.2"
              width="100%"
              top="0"
              left="0"
              right="0"
              bottom="0"
            />

            <AnimatePresence>
              <P
                variant="standard-bold"
                position="absolute"
                as={motion.p}
                key={itemCount}
                initial={itemCount === 1 ? {} : { y: 10, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ ease: 'easeOut', duration: 0.5, delay: 0.3 }}
                exit={{ y: -10, opacity: 0 }}
              >
                {itemCount}
              </P>
            </AnimatePresence>
          </Flex>
        }
        rightText={price}
        onClick={onClick}
      >
        <Label variant="button-medium">View Order</Label>
      </Button>
    </IOSButtonWrapper>
  );
};

ScreenButton.propTypes = {
  itemCount: PropTypes.number,
  onClick: PropTypes.func,
  price: PropTypes.string,
};

ScreenButton.defaultProps = {
  itemCount: 0,
  onClick: null,
  price: null,
};

export { ScreenButton };
